import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/services/common/common.service';
import { SeoService } from 'src/services/seo/seo.service';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss']
})
export class ResourcesComponent implements OnInit {

  /**
   * Creates an instance of resources component.
   * @param commonService
   */
  constructor(public commonService: CommonService, private seoService: SeoService) { }

  resourceList: any = [1, 2, 3, 4, 5]
  ngOnInit(): void {
    this.seoService.setMetaTags(
      'Mental Health Resources, Support for Suicidal Thoughts',
      'Find trusted mental health resources, practical guides, and support for suicidal thoughts to help you navigate emotional distress and difficult moments.'
    );
  }

}
 